import { BaseModel } from "@blue-chip/core";
import SpecRequirement from "./SpecRequirement";
import File from "./File";

export default class SubmittalFile extends BaseModel {
  static get belongsTo() {
    return [File, SpecRequirement];
  }
}
